import { IonButton, IonLabel } from '@ionic/react'
import React from 'react'
import { useDispatch } from 'react-redux'
import { getCurrentTime } from '../../utilities'
import { IButton } from '../button/Button.component'

const CurrentTimeButton: React.FC<IButton> = (props: IButton) => {
  const { action, color, size, fill, expand } = props
  const dispatch = useDispatch()

  return (
    <IonButton
      onClick={() => dispatch({ type: action })}
      color={color ? color : 'primary'}
      size={size ? size : 'default'}
      fill={fill ? fill : 'solid'}
      expand={expand ? expand : 'block'}>
      <IonLabel>{getCurrentTime()}</IonLabel>
    </IonButton>
  )
}

export default CurrentTimeButton
